import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { GapEnum } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { useTranslation } from 'react-i18next';

import { NetworkStateChartComponent } from './network-state-chart/network-state-chart.component';

export const NetworkCardComponent = (): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <Card flex={1} gap={GapEnum.M}>
      <AccentTitle
        as={HeadingEnum.H3}
        icon="terminal"
        variant={AccentVariantEnum.Charging}
        text={t('$.dashboard.disponibility.title')}
      />
      <NetworkStateChartComponent />
    </Card>
  );
};
